// extracted by mini-css-extract-plugin
module.exports = {"package-layout":"_4f720283bf--package-layout--P1G5V"};